import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { VIEW_PAGE_LABELS_METRIC_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const VIEW_PAGE_LABELS_METRIC: PageSegmentLoadMetric = createPageSegmentLoadMetric({
	key: VIEW_PAGE_LABELS_METRIC_KEY,
});
